/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import DTOAddInsuranceModal from './DTOAddInsuranceModal';
import AddInsuranceModalPresenter from './AddInsuranceModalPresenter';
import { useAppDispatch, useAppSelector } from '../../../../infra/hooks';
import {
  setInsuranceList,
  setInsuranceListLoader,
} from '../../../../infra/aggregates/myProfile/insuranceAggregates/insuranceListSlice';
import {
  setExpiredInsuranceList,
  setExpiredInsuranceListLoader,
} from '../../../../infra/aggregates/myProfile/insuranceAggregates/expiredInsuranceSlice';

import toast from 'react-hot-toast';
import { insuranceServices } from '../../../../api/services/insuranceServices';

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  trans?: any;
}

const AddInsuranceModalController = ({
  isModalOpen,
  closeModal,
  trans,
}: ModalInterface) => {
  const selector = useAppSelector((state) => state.authSlice);
  const storeInsurances: any = useAppSelector(
    (state) => state.insuranceListSlice?.insuranceList,
  );
  const storeExpiredInsurances: any = useAppSelector(
    (state) => state.expiredInsuranceSlice?.expiredInsurance,
  );

  const [allInsurers, setAllInsurers] = useState([]);
  const [allPolicies, setAllPolicies] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useAppDispatch();

  const getData = (data: any) => {
    addInsurance(data);
  };

  const callBackGetInsurerTypes = (data: any) => {
    setAllInsurers(data);
  };
  const callBackGetPolicyTypes = (data: any) => {
    setAllPolicies(data);
  };

  async function addInsurance(data: any) {
    if (!isLoading){
      setIsLoading(true)
      if (selector && data) {
        const empId: any = selector.emp_id;
        const CompanyID: any = selector.company_id;
        const formData = new FormData();

        formData.append('emp_id', empId);
        formData.append('CompanyID', CompanyID);
        formData.append('insurer', data.insurer);
        formData.append('policy_type', data.policy_type);
        formData.append('policy_number', data.policy_number);
        formData.append('start_date', data.start_date);
        formData.append('end_date', data.end_date);
        formData.append('category', data.category);
        formData.append('amount', data.amount);
        if (data?.newattachement) {
          formData.append('attachments', data.attachments);
        }
        await insuranceServices
          .addInsurance(formData)
          .then((response) => {
            if (response.response == 'success') {
              const temp = storeInsurances ? [...storeInsurances] : [];
              const tempExpired = storeExpiredInsurances
                ? [...storeExpiredInsurances]
                : [];
              const expire_date = new Date(response?.data?.expiry_date);
              if (expire_date > new Date() || expire_date == new Date()) {
                temp.push(response?.data);
                dispatch(setInsuranceList(temp));
              } else {
                tempExpired.push(response?.data);
                dispatch(setExpiredInsuranceList(tempExpired));
              }
              refreshData();
              toast.success(trans('Added Successfully'));
            }
          })
          .catch((err) => {
            console.log('err--', err);
            const _errors = Object.keys(err?.response?.data?.errors);
            toast.error(
              err?.response?.data?.errors
                ? `${_errors.toString().toUpperCase()} Required!`
                : err?.response?.data?.message,
            );
          });
      }
    } else {
      closeModal()
    }
  }


  const refreshData = async () => {
    dispatch(setInsuranceListLoader(true));
    await insuranceServices
      .getInsuranceList(selector.emp_id)
      .then((response: any) => {
        if (response) {
          dispatch(setInsuranceList(response?.data));
          dispatch(setInsuranceListLoader(false));
        } else {
          dispatch(setInsuranceListLoader(true));

          return;
        }
      })
      .catch((err) => toast.error(err?.response?.data?.message));

    //expired insurance
    dispatch(setExpiredInsuranceListLoader(true));
    const response = await insuranceServices.getExpiredInsurance(
      selector.emp_id,
    );
    if (response) {
      dispatch(setExpiredInsuranceList(response?.data));
      dispatch(setExpiredInsuranceListLoader(false));
    } else {
      dispatch(setExpiredInsuranceListLoader(false));
      return;
    }
    closeModal();
    setIsLoading(false)
  };
  return (
    <>
      <DTOAddInsuranceModal
        setAllInsurerTypesData={callBackGetInsurerTypes}
        setAllPolicyTypesData={callBackGetPolicyTypes}
      />

      <AddInsuranceModalPresenter
        callBackGetData={getData}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        allInsurerTypes={allInsurers}
        allPolicyTypes={allPolicies}
        trans={trans}
      />
    </>
  );
};

export default AddInsuranceModalController;